module.exports = __webpack_public_path__ + "first-20_hologram.jpg?1337fd986991b1272c47206600c841b1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_hologram.jpg
// module id = 499
// module chunks = 0